

<body class="coming-soon-page">

    <!-- Your Content -->

    <section class="coming-soon">


        <h1 class="bg-title">COMING SOON</h1>
        <!-- Top Section -->
        <div class="content-bg">
            <div class="hero-section">

                <div class="logo-box">
                    <img src="../../../assets/images/belakwheels/coming-soon/belak_logo.png" alt="Belak Logo">
                </div>

                <div class="content-wrapper container">
                    <div class="row">
                        <div class="left-content">
                            <p>
                                Born from a passion for speed and precision, Belak Industries has
                                become a trusted name in the world of competitive drag racing.
                            </p>

                            <p>
                                Every wheel we design is forged with purpose—lightweight, strong,
                                and engineered to meet the extreme demands of the track.
                            </p>

                            <p>
                                From beadlock rears to ultra-skinny fronts, Belak wheels are built
                                for racers who refuse to compromise.
                            </p>

                            <p>
                                Proudly made in the USA and trusted by top-tier drivers.
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </section>

    <!-- Bottom Section -->
    <section class="gallery-section">
        <div class="contact-section">
            <div class="contact-content">
                <h2>
                    WHETHER YOU'RE LOOKING FOR PRODUCT INFORMATION,<br>
                    DEALER OPPORTUNITIES, OR GENERAL INQUIRIES,<br>
                    OUR TEAM IS HERE TO HELP.
                </h2>

                <div class="contact-info">
                    <span>13130 SW 128th St # 7-8</span>
                    <span class="divider">|</span>
                    <span>Miami, FL 33186</span>
                    <span class="divider">|</span>
                    <a href="tel:7862938876" class="text-decoration-none">
                        <span class="text-black">786-293-8876</span>
                    </a>
                    <span class="divider">|</span>
                    <a class="text-black" href="mailto:belakindustries@yahoo.com">
                        <span class="fw-bold text-decoration-none">belakindustries@yahoo.com</span>
                    </a>
                </div>

                <div class="social-icons">
                    <a href="https://www.facebook.com/BelakIndustries/" target="_blank"> <img src="../../../assets/images/belakwheels/coming-soon/fb_icon.png"> </a>
                    <a href="https://www.instagram.com/belakindustries/?hl=en" target="_blank"> <img src="../../../assets/images/belakwheels/coming-soon/insta_icon.png"> </a>
                    <a href="https://www.youtube.com/user/BELAKindustries" target="_blank"> <img src="../../../assets/images/belakwheels/coming-soon/youtube_icon.png"> </a>
                </div>
            </div>
        </div>
    </section>


</body>

